import React, { Component } from 'react';

class Counter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            limit: this.props.limit
        }
    }

    handleOnChange(v) {
        if(this.props.onChange) {
            this.props.onChange(v);
        }
    }

    handleIncrement() {
        if(this.state.value + 1 <= this.props.limit) {
            this.setState((state) => {
                this.handleOnChange(state.value + 1);
                return {
                    ...state,
                    value: state.value + 1
                }
            });
        }
    }

    handleDecrement() {
        if(this.state.value - 1 >= 0) {
            this.setState((state) => {
                this.handleOnChange(state.value - 1);
                return {
                    ...state,
                    value: state.value - 1
                }
            });
        }
    }

    render() { 
        return (
            <div className="hw-widget__counter">
                <div className={"hw-widget__counter__dec" + (this.state.value <= 0 ? " hw-widget__counter--disabled" : "")} onClick={() => this.handleDecrement()}>
                    <i class="fas fa-minus"></i>
                </div>
                <div className="hw-widget__counter__val">
                    {this.state.value}
                </div>
                <div className={"hw-widget__counter__inc" + (this.state.value >= this.props.limit ? " hw-widget__counter--disabled" : "")} onClick={() => this.handleIncrement()}>
                    <i class="fas fa-plus"></i>
                </div>
            </div>
        );
    }
}
 
export default Counter;